export enum OrderTypes {
  GET_ALL_ORDERS = 'GET_ALL_ORDERS',
  GET_ONE_ORDER = 'GET_ONE_ORDER',
  UPDATE_ORDER_DELIVERER_SUCCESS = 'UPDATE_ORDER_DELIVERER_SUCCES',
  UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS',
  UPDATE_ORDER_STATUS_SUCCESS = 'UPDATE_ORDER_STATUS_SUCCESS',
  UPDATE_ORDER_FAILED = 'UPDATE_ORDER_FAILED',
  UPDATE_ORDER_DELIVERER_FAILED = 'UPDATE_ORDER_DELIVERER_FAILED',
}
